import React from 'react';
import styled from 'styled-components/macro';
import union from '../resources/Union.svg';

interface Props {
	children: React.ReactNode;
	disabled?: boolean;
	onClick?: any;
	isSelected?: boolean;
	tooltipText?: string;
	tooltipEnabled?: boolean;
}

const PaymentButton = ({ children, disabled, onClick, isSelected, tooltipText, tooltipEnabled }: Props) => {
	return (
		<StyledPaymentButton disabled={disabled} onClick={onClick} isSelected={isSelected}>
			<Container>
				<StyledChildrenDiv disabled={disabled}>{children}</StyledChildrenDiv>
				{tooltipEnabled && (
					<StyledSpan>
						<StyledTooltip>{tooltipText}</StyledTooltip>
						<StyledUnionButton src={union} alt="union" />
					</StyledSpan>
				)}
			</Container>
		</StyledPaymentButton>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: space-between;
`;

const StyledTooltip = styled.div`
	visibility: hidden;
	opacity: 0;
	transition: opacity 0.3s ease;
	font-family: museo-sans;
	position: absolute;
	background: #333333;
	color: #ffffff;
	border-radius: 5px;
	padding: 16px 14px;
	text-align: center;
	font-size: 13px;
	line-height: 15px;
	font-weight: 400;
	text-align: left;
	box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
	z-index: 1000;
	max-width: 240px;
	width: max-content;
	min-width: 100px;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 8px;
	pointer-events: none;
	white-space: pre-wrap;
	word-wrap: break-word;
	box-sizing: border-box;

	/* Tooltip arrow */
	::after {
		content: '';
		position: absolute;
		top: -20px;
		left: 50%;
		transform: translateX(-50%);
		border-width: 10px;
		border-style: solid;
		border-color: transparent transparent #333333 transparent;
	}

	/* For screens smaller than 700px */
	@media (max-width: 700px) {
		left: auto;
		right: -25px;
		transform: none;
		::after {
			left: auto;
			right: 36px;
			transform: translateX(50%);
		}
	}
`;

const StyledSpan = styled.span`
	position: relative;
	display: inline-block;
	&:hover ${StyledTooltip} {
		visibility: visible;
		opacity: 1;
	}
`;

const StyledUnionButton = styled.img`
	position: relative;
`;

interface ButtonProps {
	isSelected?: boolean;
}

const StyledPaymentButton = styled.button<ButtonProps>`
	display: flex;
	width: 280px;
	padding: ${({ isSelected }) => (isSelected ? '12px 20px' : '16px 24px')};
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	border-radius: 8px;
	cursor: pointer;
	background: ${({ isSelected }) => (isSelected ? '#FFECF0' : 'white')};
	border: ${({ isSelected }) => (isSelected ? '4px solid #EA0029' : '1px solid #EA0029')};
	&:not(:disabled):hover {
		background: #ffecf0;
	}
	&:not(:disabled):active {
		border: 4px solid #ea0029;
		background: #ffecf0;
	}
	&:disabled {
		cursor: not-allowed;
		color: #919191;
		border: 1px solid #919191;
	}
`;

interface StyledChildrenDivProps {
	disabled?: boolean;
}

const StyledChildrenDiv = styled.div<StyledChildrenDivProps>`
	width: inherit;
	p {
		color: ${({ disabled }) => (disabled ? '#919191' : 'auto')};
	}
`;

export default PaymentButton;
